// extracted by mini-css-extract-plugin
module.exports = {"label":"GroupNode_label__ieOUX","action":"GroupNode_action__u8yKG","wrapper":"GroupNode_wrapper__zIE83"};